import Viewer from 'bee-viewer'

export default Viewer
